import React, { Component } from 'react';
import { createContainer } from '@dbk-legacy/muster/react';

class SkipMainContent extends Component {
    render(){
        const { auth: {authorised}, i18n: { messages }} = this.props;
        return(
            <div>
                    { authorised &&  <a href='#main-content' tabIndex={0} className='skip-to-content'>{messages['app.accessibility.skipmainContent']}</a> }         
            </div> 
        )
    }
}

export default createContainer({
    $queries: {
      auth: {
        authorised: true,
      },
      i18n: {
        messages: true,
      },
    }
})(SkipMainContent);

